import React from "react";
import PropTypes from "prop-types";

const Error = ({message}) =>{
return(
    <label className="text-sm font-medium text-red-500 block mt-1">{message}</label>
)
}

Error.protoTypes = {
    message: PropTypes.string
}

Error.defautProps = {
    message: ""
}

export default Error;